import { render, staticRenderFns } from "./Announcement.vue?vue&type=template&id=a72518cc&scoped=true"
import script from "./Announcement.vue?vue&type=script&lang=js"
export * from "./Announcement.vue?vue&type=script&lang=js"
import style0 from "./Announcement.vue?vue&type=style&index=0&id=a72518cc&prod&lang=stylus&scoped=true"
import style1 from "./Announcement.vue?vue&type=style&index=1&id=a72518cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a72518cc",
  null
  
)

export default component.exports